import React from 'react';
import PackageVariantClosedIcon from 'mdi-react/PackageVariantClosedIcon';
import SteeringIcon from 'mdi-react/SteeringIcon';
import Grid from 'pencil/Grid';
import AppIcon from 'domain/fuse/auth/components/AppIcon';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import Tooltip from 'pencil/Tooltip';
import DashboardIcon from 'pencil/icons/Dashboard';
import Equalizer from 'pencil/icons/Equalizer';
import SettingsIcon from 'pencil/icons/Settings';
import { titleMapping } from 'domain/layout/constants';

const GroupSidebar = ({
  isAllowedMenuItem,
  authorities,
  classes,
  toggleGroupDrawer,
  isGroupActive,
}) => {
  let auth;
  if (authorities?.length) {
    auth = authorities[0] === 'FINANCE_ADMIN' ? ['FINANCE_ADMIN', 'AUTHENTICATED'] : [];
  } else auth = [];

  return (
    <>
      <div className={classes.sidebarWrapper}>
        <Grid item xs={12}>
          <AppIcon className={classNames(classes.appIcon)} />
        </Grid>
        {isAllowedMenuItem('PULSE', authorities) && (
          <Grid item xs={12}>
            <NavLink
              to="#"
              className={classes.link}
              activeClassName={classes.activeGroup}
              onClick={() => toggleGroupDrawer(titleMapping.pulse, 'dashboard')}
              isActive={(match, location) => isGroupActive(match, location, 'dashboard')}
            >
              <Tooltip title={titleMapping.pulse} placement="top">
                <DashboardIcon className={classes.group} />
              </Tooltip>
            </NavLink>
          </Grid>
        )}

        {isAllowedMenuItem('GENERATE_PAYABLE', auth) && (
          <Grid item xs={12}>
            <NavLink
              to="#"
              className={classes.link}
              activeClassName={classes.activeGroup}
              onClick={() =>
                toggleGroupDrawer(
                  authorities.includes('FINANCE_ADMIN')
                    ? titleMapping.finance
                    : titleMapping.reconciliation,
                  'finance',
                )
              }
              isActive={(match) => isGroupActive(match, location, 'finance')}
            >
              <Tooltip title={titleMapping.finance} placement="top">
                <Equalizer className={classes.group} />
              </Tooltip>
            </NavLink>
          </Grid>
        )}

        {isAllowedMenuItem('SHIPPING', authorities) && (
          <Grid item xs={12}>
            <NavLink
              to="#"
              className={classes.link}
              activeClassName={classes.activeGroup}
              onClick={() => toggleGroupDrawer(titleMapping.search, 'shipping')}
              isActive={(match) => isGroupActive(match, location, 'shipping')}
            >
              <Tooltip title={titleMapping.shipping} placement="top">
                <PackageVariantClosedIcon className={classes.group} />
              </Tooltip>
            </NavLink>
          </Grid>
        )}

        {isAllowedMenuItem('DRIVERS', authorities) && (
          <Grid item xs={12}>
            <NavLink
              data-qa="sidebar-drivers"
              to="#"
              className={classes.link}
              activeClassName={classes.activeGroup}
              onClick={() => toggleGroupDrawer(titleMapping.drivers, 'drivers')}
              isActive={(match) => isGroupActive(match, location, 'drivers')}
            >
              <Tooltip title={titleMapping.drivers} placement="top">
                <SteeringIcon className={classes.group} />
              </Tooltip>
            </NavLink>
          </Grid>
        )}

        {isAllowedMenuItem('SETTINGS', authorities) && (
          <Grid item xs={12}>
            <NavLink
              data-test="sidebar-addresses"
              to="#"
              className={classes.link}
              activeClassName={classes.activeGroup}
              onClick={() => toggleGroupDrawer(titleMapping.addresses, 'settings')}
              isActive={(match) => isGroupActive(match, location, 'settings')}
            >
              <>
                <Tooltip title={titleMapping.settings} placement="top">
                  <SettingsIcon className={classes.group} />
                </Tooltip>
              </>
            </NavLink>
          </Grid>
        )}
      </div>
    </>
  );
};

export default GroupSidebar;
